import React from 'react';
import styled from 'styled-components';

interface BTInputBoxProps {
  type?: string;       // 입력 타입
  borderColor?: string; // ✅ border 색상
  value?: string;       // ✅ 입력값 바인딩
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; // ✅ 변경 핸들러
}

const BTInputBox: React.FC<BTInputBoxProps> = ({ type = 'text', borderColor, value, disabled, onChange }) => {
  return (
    <StyledInput
      type={type}
      value={value}
      onChange={onChange}
      {...(disabled !== undefined ? { disabled } : {})}
      $borderColor={borderColor}
    />
  );
};

export default BTInputBox;

// ✅ $borderColor → styled-components 전용 프롭
const StyledInput = styled.input<{ $borderColor?: string }>`
  box-sizing: border-box;       /* ✅ 폭 계산을 테두리+패딩 포함으로 */
  max-width: 100%;              /* ✅ 혹시 모를 부모 초과 방지 */
  border: 1px solid ${({ $borderColor }) => $borderColor || '#adb5bd'};  // ✅ border 색상 적용
  border-radius: 4px;
  padding: 0 10px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  color: #232d42;
  background-color: transparent;
  outline: none;

  &::placeholder {
    color: #adb5bd;
  }
`;